var render = function render(){var _vm=this,_c=_vm._self._c;return _c('messagebox-enhanced',{attrs:{"headerText":_vm.$t('global.saverecord'),"id":"change-watcher-alert-msgbox","ok":true,"cancel":true,"okText":_vm.$t('global.discard'),"cancelText":_vm.$t('global.cancel')},on:{"ok":_vm.performIgnore}})
}
var staticRenderFns = []

export { render, staticRenderFns }